import { createContext, SetStateAction, Dispatch } from 'react';

/**
 * id is an optional string to identify message uniqueness. If messages are unique then it's OK to leave out
 */
export type AlertMessage = {
  severity: 'warning' | 'error' | 'success';
  text: string;
  id?: string;
};

export interface AlertContextState {
  alertMessage: AlertMessage | undefined;
  setAlertMessage: Dispatch<SetStateAction<AlertMessage | undefined>>;
  alertsVisible: boolean;
  setAlertsVisible: Dispatch<SetStateAction<boolean>>;
}

export const AlertContext = createContext<AlertContextState>(undefined as never);
